module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_5010.5b154b50.png";